import React, { useState, useEffect, useContext } from "react";
import PartnerProductReadOnlyRow from "./PartnerProductReadOnlyRow";
import PartnerProductTableRow from "./PartnerProductTableRow";
import UserPartnerDD from "./UserPartnerDD";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function PartnerProductTable({ key, setPartnerProduct, loginId, companyId, userPartnerList, setSupplierId, supplierId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isPartnerProductLoading, setIsPartnerProductLoading] = useState(false);
	const [partnerProducts, setPartnerProducts] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		companyProductKey: 0,
		partnerKey: supplierId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		if (supplierId > 0) {
			initialValues.partnerKey = supplierId;
			setFormValues({ ...formValues, ["partnerKey"]: supplierId });
			removeRowTable();
			setPartnerProducts([]);
			setIsPartnerProductLoading(false);
			fetchPartnerProducts();
		}
	}, [supplierId]);

	const handleClose = (event) => {
		setPartnerProduct(false);
	};

	function fetchPartnerProducts() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0
			|| !initialValues.loginId || !supplierId || supplierId === 0) {
			return;
		}
		resetCounter();
		setIsPartnerProductLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, partnerKey: supplierId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserPartnerProduct", "/Service/PartnerSubsService/GetUserPartnerProduct", requestOptions, retrievePartnerProductSuccess, retrievePartnerProductFail);
		} catch (error) {
			setIsPartnerProductLoading(false);
			throw new Error(error.message);
		}
	}

	function retrievePartnerProductFail(redirect) {
		setIsPartnerProductLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getProdFailed"));
	}

	function retrievePartnerProductSuccess(responseData) {
		let fetchUserPartnerProductsResponse;
		if (responseData) {
			fetchUserPartnerProductsResponse = responseData.fetchUserPartnerProductsResponse;
			if (fetchUserPartnerProductsResponse && fetchUserPartnerProductsResponse.errorCode === "0") {
				setPartnerProducts(fetchUserPartnerProductsResponse.products.slice())
			} else if (fetchUserPartnerProductsResponse && fetchUserPartnerProductsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserPartnerProductsResponse) {
				setError(t("error.error") + " " + fetchUserPartnerProductsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsPartnerProductLoading(false);
	}

	const handleDeleteClick = (event, partnerProductItem, completeCallback) => {
		event.preventDefault();
		deletePartnerProduct(partnerProductItem, completeCallback);
	};
	const deletePartnerProduct = (partnerProductItem, completeCallback) => {
		let action = 3;
		if (partnerProductItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			companyProductKey: partnerProductItem.companyProductKey,
			partnerKey: partnerProductItem.partnerKey,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserPartnerProduct", "/Service/PartnerSubsService/DeleteUserPartnerProduct", requestOptions, deletePartnerProductSuccess, deletePartnerProductFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deletePartnerProductFail(redirect, completeCallback) {
		setError(t("error.userProdEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deletePartnerProductSuccess(responseData, completeCallback) {
		let deleteUserPartnerProductResponse;
		if (responseData) {
			deleteUserPartnerProductResponse = responseData.deleteUserPartnerProductResponse;
			if (deleteUserPartnerProductResponse) {
				if (deleteUserPartnerProductResponse.errorCode === "0") {
					resetRowTable();
					refreshPartnerProduct();
				} else {
					setError(t("error.error") + " " +
						deleteUserPartnerProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};
	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();

	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (partnerProducts.length > 0) {
				partnerProducts.map((partnerProductItem, index) => {
					if (partnerProductItem.companyProductKey === setValues.companyProductKey
						&& partnerProductItem.partnerKey === setValues.partnerKey) {
						setError(t("error.prodDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				savePartnerProduct(action, setValues, completeCallback);
			}
		}
	};
	const savePartnerProduct = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			companyProductKey: setValues.companyProductKey,
			partnerKey: setValues.partnerKey,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserPartnerProduct", "/Service/PartnerSubsService/AddUpdateUserPartnerProduct", requestOptions, savePartnerProductSuccess, savePartnerProductFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function savePartnerProductFail(redirect, completeCallback) {
		setError(t("error.partnerGetProdFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function savePartnerProductSuccess(responseData, completeCallback) {
		let addUpdateUserPartnerProductResponse;
		if (responseData) {
			addUpdateUserPartnerProductResponse = responseData.addUpdateUserPartnerProductResponse;
			if (addUpdateUserPartnerProductResponse) {
				if (addUpdateUserPartnerProductResponse.errorCode === "0") {
					resetRowTable();
					refreshPartnerProduct();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserPartnerProductResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshPartnerProduct() {
		fetchPartnerProducts();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isPartnerProductLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<UserPartnerDD loginId={loginId} companyId={companyId} setSupplierId={setSupplierId} userPartnerList={userPartnerList} 
							supplierId = {supplierId} />
						</div>
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					{(supplierId > 0) ?
						<div className="row">
							<div className="col">
								<table className="list-table" role="table">
									<thead>
										<tr role="row">
											<th className="list-th">{t("page.prodName")}</th>
											<th className="list-th">{t("page.prodNum")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</thead>
									<tbody role="rowgroup">
										{add && addRowTop &&
											<PartnerProductTableRow
												index={count}
												partnerKey={supplierId}
												buyerKey={companyId}
												handleSubmit={handleSubmit}
												setError={setError}
												t={t}
												setAdd={setAdd}
												oddIdx={((partnerProducts.length % 2) > 0) ? true : false} />
										}
										{(partnerProducts.length > 0) ? (
											partnerProducts.map((partnerProductItem, index) => (
												<PartnerProductReadOnlyRow
													index={count}
													t={t}
													partnerProductItem={partnerProductItem}
													handleDeleteClick={handleDeleteClick}
													oddIdx={((index % 2) > 0) ? true : false}
													add={add}
													setError={setError}
												/>
											))
										) : (<></>)}
										{add && addRowBottom &&
											<PartnerProductTableRow
												index={count}
												partnerKey={supplierId}
												buyerKey={companyId}
												handleSubmit={handleSubmit}
												setError={setError}
												t={t}
												setAdd={setAdd}
												oddIdx={((partnerProducts.length % 2) > 0) ? true : false} />
										}
									</tbody>
									{(partnerProducts.length > 10) ? (<tfoot>
										<tr role="row">
											<th className="list-th">{t("page.prodName")}</th>
											<th className="list-th">{t("page.prodNum")}</th>
											<th className="list-th">{t("page.status")}</th>
											<th className="list-th" style={{ maxWidth: "9vw" }}>
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
													{t("page.addRow")}
												</button>&nbsp;&nbsp;
												<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
													{t("page.delRow")}
												</button>
											</th>
										</tr>
									</tfoot>
									) : (<></>)}
								</table>
								<div className="row">
									<div className="col mt-3">
										{(error) ? (
											<div id="inerrorMessage1" className="errorblock">
												{error}
											</div>
										) : (<></>)}
									</div>
								</div>
								<div className="footer">
									<input
										type="button"
										name="edit-part-prod-close"
										id="edit-part-prod-close"
										className="btn btn-secondary btn-block" data-dismiss="modal"
										onClick={(e) => handleClose(e)}
										style={{ marginTop: "10px", marginBottom: "10px" }}
										value={closeText}
									></input>
								</div>
							</div>
						</div> :
						(!userPartnerList || userPartnerList.length === 0) ?
							<>
								<div className="row">
									<div className="col mt-3">
										<div id="inerrorMessage1" className="errorblock">
											{t("error.partnerReqd")}
										</div>
									</div>
								</div>
								<div className="footer">
									<input
										type="button"
										name="edit-part-prod-close"
										id="edit-part-prod-close"
										className="btn btn-secondary btn-block" data-dismiss="modal"
										onClick={(e) => handleClose(e)}
										style={{ marginTop: "10px", marginBottom: "10px" }}
										value={closeText}
									></input>
								</div>
							</> : (<></>)}
				</div>
				: null}
		</>
	);
}
export default PartnerProductTable;